import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { ITransformedIMockExamQuestionResponse, IQuestionMockExam } from '../exam-agencies/mock-exam-question/mock-exam-question.component';
import { StudyunitPracticeTestService } from 'src/app/Services/studyunit-practice-test.service';
import { IExtractedQuestion, IExtractedStudyUnit, IStudyunitPracticeTestQuestion } from 'src/app/interfaces/practiceTest';

@Component({
  selector: 'app-studyunit-practice-test-questions',
  templateUrl: './studyunit-practice-test-questions.component.html',
  styleUrls: ['./studyunit-practice-test-questions.component.css'],
})
export class StudyunitPracticeTestQuestionsComponent implements OnInit {
  PracticeTestId: number = 0;
  private destroy$ = new Subject<void>(); // Used for unsubscribing
  studyUnitQuestions: IExtractedStudyUnit[] = [];
  courseId: number;
  MockExamSequenceNumber: number;
  ExamAgencyName: any;
  CourseName: any;
  ExamYear: any;
  MocKExamSequenceNumber: number;
  subjectId: number;

  constructor(
    private ExamService: ExamManagementService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: ModalService,
    private readonly toaster: ToastrService,
    private practiceTestService: StudyunitPracticeTestService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((queryParams) => {
        this.courseId = +queryParams['c_id'];
        this.MockExamSequenceNumber = +queryParams['m_Seq'];
        this.ExamAgencyName = queryParams['eA_Name'];
        this.CourseName = queryParams['c_Name'];
        this.ExamYear = queryParams['eY_Name'];
        this.MocKExamSequenceNumber = +queryParams['e_Seq'];
        this.subjectId = +queryParams['sub_Id'];
      });
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.PracticeTestId = +res.id;
      this.getStudyUnitPracticeTestQuestions();
    });
  }

  getStudyUnitPracticeTestQuestions() {
    const payload = {
      CourseTestId: this.PracticeTestId,
      CourseTestStatusTypeCode: null,
    };
    this.practiceTestService.getStudyUnitPracticeTestQuestion(payload).subscribe((res) => {
      this.studyUnitQuestions = res;
    });
  }

  AddEditQuestion(item: IExtractedStudyUnit) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        c_id: this.courseId,
        eA_Name: this.ExamAgencyName,
        c_Name: this.CourseName,
        eY_Name: this.ExamYear,
        s_id: item.Study_Unit_Id,
        t_q: item.Total_Number_Of_Question,
        c_q: item.Current_Number_Of_Question,
        s_name: item.Study_Unit_Name,
        // m_Seq: this.MockExamSequenceNumber,
      },
      skipLocationChange: false,
    };
    this.router.navigate(
      ['Exam/StudyUnit/AddEditPracticeQuestion', this.PracticeTestId],
      navigationExtras
    );
  }
  async onDelete(question: IExtractedQuestion) {
    try {
      const result = await this.modalService.open(
        'Confirmation',
        `Do you want to remove this Question?`
      );

      if (result) {
        const payload = {
          UDTTestQuestion: [
            {
              CourseTestId: this.PracticeTestId,
              QuestionId:String(question.Question_ID),
              QuestionNumber: 0,
              RightAnswerScore: 0,
              WrongAnswerScore: 0,
              TimeToAnswerInSeconds: 0,
              OptionalQuestionInd: 'N',
              SelectedIND: 'N',
            },
          ],

          UDTTestQuestionAnswerChoice: question.Answer_Choices.map(
            (choice) => ({
              CourseTestId: this.PracticeTestId,
              QuestionId: String(question.Question_ID),
              AnswerChoiceId: choice.Answer_Choice_Id, // Ensure number type
              AnswerChoiceSequenceNumber: 0,
              SelectedIND: 'N',
            })
          ),
        };

        this.ExamService.insertOrUpdateTestQuestion(payload).subscribe(
          (res) => {
            console.log(res);
            this.toaster.success('Questions Deleted successfully', '', {
              timeOut: ConstantVars.ToastSucessTimeout,
            });
            this.getStudyUnitPracticeTestQuestions();
          },
          (error) => {
            console.log(error);

            this.toaster.error(error.error.Message, '', {
              timeOut: ConstantVars.ToastErrorTimeout,
            });
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  onEdit(
    item: IExtractedStudyUnit,
    question: IExtractedQuestion
  ) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        c_id: this.courseId,
        eA_Name: this.ExamAgencyName,
        c_Name: this.CourseName,
        eY_Name: this.ExamYear,
        s_id: item.Study_Unit_Id,
        t_q: item.Total_Number_Of_Question,
        c_q: item.Current_Number_Of_Question,
        s_name: item.Study_Unit_Name,
        q_id: question.Question_ID,
        // m_Seq: this.MockExamSequenceNumber,
      },
      skipLocationChange: false,
    };
    this.router.navigate(
      ['Exam/AddEditMockExamsQuestion', this.PracticeTestId],
      navigationExtras
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next(); // Emit value to trigger unsubscription
    this.destroy$.complete(); // Ensures Subject is fully closed
    const fullUrl = this.router.url;

    // If the current URL does NOT include 'Exam/StudyMaterial', clear the selection
    if (!fullUrl.includes('Exam/StudyUnit')) {
      this.practiceTestService.setSelectedPracticeTestId(null);
    }
  }

}
